export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-sketches-0cd4097a8481cf7b66a2154490cbcb57.png";